import React from "react";
import Button from "../../components/button/Button";
import { Container, SpecialText, Heading, Text } from "./Contact.Styled";
import { motion } from "framer-motion";
import { commonUpAppearVariants } from "../../animations/motion";

const Contact = () => {
  return (
    <Container
      id="Contact"
      as={motion.section}
      variants={commonUpAppearVariants}
      initial="closed"
      whileInView="open"
      viewport={{ once: true, amount: 0.25 }}
    >
      <SpecialText>04. Start a Conversation</SpecialText>
      <Heading>Let’s Work Together</Heading>
      <Text>
        If you need an experienced front-end partner to ship a new product,
        strengthen an existing codebase, or turn a complex brief into a
        production-ready experience, I’d be glad to hear what you’re building.
      </Text>
      <Button href="mailto:viethoang.ng7@gmail.com">Discuss a Project</Button>
    </Container>
  );
};

export default Contact;
